export const HOME = '/';

export const LOGIN = '/login';

export const LOGOUT = '/logout';

export const MAIL_AUTH = '/mail_auth';
export const MAIL_AUTH_SENT = '/mail_auth_sent';
export const MAIL_AUTH_VERIFY = '/mail_auth_verify';
export const MAIL_PRIVATE_VERIFY = '/mail_private_verify';
export const MAIL_AC_VERIFY = '/mail_ac_verify';

export const REGISTS_DIR_FIRST = '/regists';
export const REGISTS_PROFILE = '/regists/profile';
export const REGISTS_EDUCATION = '/regists/education';
export const REGISTS_SKILL = '/regists/skill';
export const REGISTS_IT_SKILL = '/regists/it_skill';
export const REGISTS_WISH = '/regists/wish';
export const REGISTS_FOLLOW = '/regists/follow';
export const REGISTS_CONFIRM = '/regists/confirm';
export const REGISTS_AC_EMAIL = '/regists/ac_email';
export const REGISTS_FINISH = '/regists/finish';

export const STUDENT_CARD = '/student_card';
export const STUDENT_CARD_APPLIED = '/student_card/applied';

export const REMIND_PASS = '/remindpass';

export const RESET_PASS = '/resetpass';

export const EVENT = '/event';

export const BOX_DIR_FIRST = '/box';

export const BOX_ANSWERS = '/box/answers';

export const BOX_AUTH = '/box/auth';

export const COMPANIES = '/company';
export const COMPANY_FOLLOW_RANKING = '/company/follow_ranking';

export const RECRUITING_INFO = '/recruiting_info';

export const COLUMNS = '/columns';

export const QUESTIONS = '/questions';

export const RECRUITINGS = '/recruiting_info';

export const REPORTS = '/reports';

export const COMMUNITY = '/questions';

export const SCOUTS = '/scouts';

export const RULE_CONFIRM = '/rule/confirm';

export const NEW_GRADES_PROFILE_UPDATE = '/new_grades';

export const NEW_GRADES_EDIT_DEVELOPMENT_EXPERIENCE =
  '/new_grades/edit_development_experience';

export const NEW_GRADES_EDIT_WISH_STATUS = '/new_grades/edit_wish_status';

export const CORPORATE_PRIVACY_POLICY = '/corporate_privacy_policy';

export const SERVICE_PRIVACY_POLICY = '/service_privacy_policy';

export const INQUIRY = '/inquiry';

export const INQUIRY_FOREIGN_UNIV = '/inquiry/foreign_univ';

export const DISCLAIMER = '/disclaimer';

export const TERMS = '/terms';

export const FOLLOW_COMPANIES = '/mypage/follow_companies';

export const HOW_TO_USE_ARTICLE = '/archives/162496';

export const REPORTS_FAQ_ARTICLE = '/archives/228146';

export const COLUMN_RECRUIT_ARTICLE =
  '/archives/db95474435a345b5b1bc0a22318048bd';

export const QUIT = '/quit';

export const QUIT_THANK_TOU = '/thankyou';

export const PROFILE_BASE = '/mypage/profile';
export const PROFILE_GENERAL = '/mypage/profile/edit/general';
export const PROFILE_AC_EMAIL = '/mypage/profile/edit/ac_email';
export const PROFILE_PR_MESSAGE = '/mypage/profile/edit/pr_message';
export const PROFILE_WISH = '/mypage/profile/edit/wish';
export const PROFILE_MENTALITY = '/mypage/profile/edit/mentality';
export const PROFILE_EDUCATION = '/mypage/profile/edit/education';
export const PROFILE_INTERN = '/mypage/profile/edit/intern';
export const PROFILE_ADDITIONAL_BACKGROUND =
  '/mypage/profile/edit/additional_background';
export const PROFILE_LANGUAGE = '/mypage/profile/edit/language';
export const PROFILE_IT_SKILL = '/mypage/profile/edit/it_skill';
export const PROFILE_FOREIGN_EXPERIENCE =
  '/mypage/profile/edit/foreign_experience';
export const PROFILE_OFFER = '/mypage/profile/edit/offer';
export const PROFILE_OFFER_EDIT = '/mypage/profile/edit/offer?mode=edit';

export const MYPAGE_SCOUT_SETTING = '/mypage/profile/edit/scout_setting';
export const MYPAGE_DM_SETTING = '/mypage/profile/edit/dm';
export const MYPAGE_POSTAL_DM_SETTING = '/mypage/profile/edit/postal_dm';
export const MYPAGE_FAVS_COMPANIES = '/mypage/favs/companies';
export const MYPAGE_FAVS_COMPANIES_RECRUITMENTS =
  '/mypage/favs/companies/recruitments';
export const MYPAGE_FAVS_COMPANIES_REPORTS = '/mypage/favs/companies/reports';
export const MYPAGE_SCOUT_RECRUITMENTS = '/mypage/scouts/recruitments';

export const JOB_HUNTING_STATUS_UPDATE = '/job_hunting_status_check';

export const BASIC_INFO_CHECK = '/basic_info_check';

export const FAQ = '/faq';

export const TAREKOMI = '/inquiry/tarekomi';

export const ADVERTISE = '/inquiry/advertise';

export const QUIT_THANKYOU = '/thankyou';

export const ENGINEER = '/engineer';

export const ENGINEER_COMPANY = '/engineer/company';

export const ENGINEER_COMPANY_REPORT = '/engineer/company/reports';

export const ENGINEER_COLUMN = '/engineer/column';

export const ENGINEER_RECRUITING_INFO = '/engineer/recruiting_info';

export const REPORT_ANALYTICS_SEARCH = '/report_analytics/search';

export const REPORT_ANALYTICS_RESULT = '/report_analytics/result';

export const LIIGA = 'https://next.gaishishukatsu.com/';

export const MOND = 'https://mond.how/';

export const HOWTELEVISION = 'https://howtelevision.co.jp/';

// iOS/Androidを自動判定して適切なストアにリダイレクトするURL
export const URL_TO_APPS_FLYER_ONE_LINK = 'http://gsskt.onelink.me/TB3c/eed800';

export const URL_TO_ANDROID_APP_WEB =
  'https://play.google.com/store/apps/details?id=com.gaishishukatsu.Gaishishukatsu&hl=ja';

export const URL_TO_iOS_APP_WEB =
  'https://itunes.apple.com/jp/app/%E3%83%88%E3%83%83%E3%83%97%E4%BC%81%E6%A5%AD%E3%81%B8%E5%86%85%E5%AE%9A%E3%82%92%E3%82%81%E3%81%96%E3%81%99%E5%B0%B1%E8%81%B7%E6%B4%BB%E5%8B%95%E3%82%A2%E3%83%97%E3%83%AA-%E5%A4%96%E8%B3%87%E5%B0%B1%E6%B4%BB%E3%83%89%E3%83%83%E3%83%88%E3%82%B3%E3%83%A0/id517232947?mt=8';

export const MYNAVI_FAIR_TEASER = '/jd2019';

export const MYNAVI_FAIR_CAREER_DISCOVERY = '/cd2019';

export const MYPAGE = '/mypage';

export const ES = '/mypage/es';

export const PASSED_ES = '/passed_es';

export const ES_NEW = '/mypage/es/new';

export const MYPAGE_REPORTS = '/mypage/reports';

export const MYPAGE_REPORTS_ADD = '/mypage/reports/add';

export const MYPAGE_ES = '/mypage/entrysheets';

export const MYPAGE_ES_ADD = '/mypage/es/new';

export const MYPAGE_INTERESTS = '/myInterests';

export const SELECTION_REPORTS = '/selection_reports';

export const EXTERNAL_SERVICES_LINE_RESULT = '/external_services/line/result';

export const EXTERNAL_SERVICES_LINE_SEETTING =
  '/external_services/line/setting';

export const RECRUITMENT_STEP_UPLOAD_FILES =
  '/recruitment_step_upload_files/view';

export const RECRUITMENT_STEP_USER_APPLIES = '/recruitment_step_user_applies';

export const RECRUITMENTS = '/recruitments';

export const ENGINEER_SKILL_CHECK_TOP = '/engineer/skill_check/top';

export const ENGINEER_AI_ES_BUILDER = '/engineer/ai-es-builder';

export const PMARK_SIGNUP = '/pmark_signup';

export const CLIP_REPORTS = '/clip/reports';
export const CLIP_POSTS = '/clip/posts';
export const ENGINEER_DRILL = '/engineer/drill';

export const PMARK = '/pmark';

export const WEB_SEMINAR = '/web_seminars/event/1';

export const NOTIFICATIONS = '/mypage/notifications';

export const SCHEDULE = '/schedule';

export const ENTRY_MANAGEMENTS_PROGRESS = '/mypage/entry_managements/progress';
export const ENTRY_MANAGEMENTS_TODO = '/mypage/entry_managements/todo';
export const ENTRY_MANAGEMENTS_CALENDAR = '/mypage/entry_managements/calendar';
export const ENTRY_MANAGEMENTS_SETTINGS = '/mypage/entry_managements/settings';
export const CAREER_ADVISER_INTERVIEW_TRAINING =
  '/career_adviser/interview_training';

export const YOUTUBE_GSSKT_CHANNEL = 'https://www.youtube.com/@gaishi-shukatsu';
